module.exports = __webpack_public_path__ + "img/jing5.dfe85993.jpg";